<template>
      <div class="review_box" >
          <div class="review_col">
            <p class="review-name" id="review-name"> {{ReviewName}} </p>
            <div class="review-star" :class= ReviewStars />
          </div>
          <div class="review_col">
                <h2 class="review-title"> {{ReviewHeader}} </h2>
                <p class="review-text"> {{ReviewSubHeader}} </p>
                <p class="review-text"> {{ReviewDescription}}</p>
          </div>
      </div>
</template>

<script>
export default {
  name: "ReviewCard",
  props: {
    ReviewStars: {
      type: String,
      required: true
    },
    ReviewDate: {
      type: String,
      required: true
    },
    ReviewName: {
      type: String,
      required: true
    },
    ReviewNameTooltip: {
      type: String,
      required: false
    },
    ReviewHeader: {
      type: String,
      required: true
    },
    ReviewSubHeader: {
      type: String,
      required: false
    },
    ReviewDescription: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
.review_box{
    height: 260px;
    margin: 24px;
    background-color: #fff;
    border: 1px solid #dfe2e5;
    overflow: hidden;
    position: relative;
}
.review_col{
    margin: 0;
    padding: 16px 24px 0 24px;
}
.review_content{
    padding: 16px;
    position: relative;
}
.review-star {
    background-size: contain;
    background-repeat: no-repeat;
    min-height: 50px;
}
.fiveStar {
    background-image: url(../isaluAssets/img/png/FiveStarRating.png);
}
.fourStar {
    background-image: url(../isaluAssets/img/jpg/bg-dashboard-new.jpg);
}
.review-name{
    color: #535353;
    font-size: 18px;
    line-height: 24px;
    position: absolute;
    right: 24px;
    top: 24px;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    letter-spacing: 0;
    margin: 0 0 10px;
    padding: 0 6px;
    -webkit-transform: translateX(-6px);
    -ms-transform: translateX(-6px);
    transform: translateX(-6px);
}
.review-title {
    border: 0;
    color: #292929;
    display: block;
    padding: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin: 0 0 4px;
}
.review-text{
    color: #535353;
    font-size: 14px;
    margin: 0 0 16px;
}

@media (min-width: 240px) and (max-width: 720px) {
  .review_box{
      width: 100%;
      margin: 0;
  }
}
</style>